import type { IKanbanTicket, IKanbanTicketDraft, TKanbanPriority } from './interfaces.js';

export const kanbanInitials = (name: string): string =>
  name.trim().split(/\s+/).map(part => part[0]).join('').slice(0, 2);

export const kanbanPriorityIcon = (priority?: TKanbanPriority): string =>
  priority === 'urgent'
    ? 'lucide:ChevronsUp'
    : priority === 'high'
      ? 'lucide:ChevronUp'
      : priority === 'low'
        ? 'lucide:ChevronDown'
        : 'lucide:Minus';

export const sortKanbanTickets = (tickets: readonly IKanbanTicket[]): IKanbanTicket[] =>
  [...tickets].sort((a, b) => a.order - b.order || a.id.localeCompare(b.id));

export const ticketLabel = (ticket: IKanbanTicket): string => `#${ticket.key} ${ticket.title}`;

export const ticketDraft = (ticket: IKanbanTicket): IKanbanTicketDraft => ({
  title: ticket.title,
  description: ticket.description ?? '',
  priority: ticket.priority ?? 'none',
  assigneeId: ticket.assignee?.id ?? '',
  parentId: ticket.parentId ?? '',
});

export const kanbanEvent = <T>(owner: HTMLElement, name: string, detail: T): void => {
  owner.dispatchEvent(new CustomEvent(name, { detail, bubbles: true, composed: true }));
};

export const kanbanError = (error: unknown): string =>
  error instanceof Error ? error.message : String(error);
